export default "__VITE_ASSET__C$4RVQWQ__"